export enum CheckboxVariants {
  PRIMARY = 'primary',
}

export const CheckboxVariantsStyles: Record<CheckboxVariants, string> = {
  [CheckboxVariants.PRIMARY]: 'custom-checkbox',
};
